export default "__VITE_PUBLIC_ASSET__5473c86c__"